module.exports = __webpack_public_path__ + "static/media/community_mind_body_fitness.82464bb8.webp";